import { isSafari } from '@/utils/browser-kit';
import { convertImageToWebp, fetchSvgContentWithCache, imageConverter } from '@/utils/file-kit';
import { TextMarkStruct } from '../types';

/**
 * 获取纹理贴图 URL
 *
 * @param url - 链接地址
 */
export const getTextureUrl = (url: string) => {
    return isSafari ? imageConverter(url, 150, 100) : convertImageToWebp(url);
};

/**
 * 加载划重点 SVG 资源
 *
 * @param source - 划重点数据
 */
export const loadTextMarkSVG = async (source: TextMarkStruct[]) => {
    const tasks = source.map((item) => {
        const src = item.data.src;
        return fetchSvgContentWithCache(src);
    });

    return Promise.all(tasks);
};
